import * as React from "react";
import { Redirect } from "react-router-dom";
import SortableTbl from "react-sort-search-table";
import Loader from 'react-loader';
import { toast, ToastContainer} from 'react-toastify';
import {Button,Col, Input, Modal, ModalHeader, ModalBody, Row} from 'reactstrap';

import FormModal from '../../../../components/Admin/FormModal/FormModal';
import FormFieldClass from '../../../../components/Admin/FormModal/FormFieldClass';
import Navbar from '../../../../components/CustomNav/CustomNav.Component';
import withServices  from '../../../../HOCs/withServices';
import { Wrapper, Content , ContentRow} from './ListTemplates.styles'

interface IProps {
    services?: any;
    location?: any;
    match?: any;
    history?: any;
}
  
interface IState {
    toLogin: boolean;
    loaded: boolean;
    data: any;
    selectedLesson: string;
    isNavigate: boolean;
    destination: string;
}

class ListTemplates extends React.Component<IProps, IState> {
    constructor(props) {
        super(props);
    
        this.state = {
          destination: '',
          toLogin: false,
          loaded: true,
          isNavigate: false,
          data: {},
          selectedLesson: '',
        };
    
        this.onLogout = this.onLogout.bind(this);
        this.onGoBack = this.onGoBack.bind(this);
        this.goToEdit = this.goToEdit.bind(this);
        this.onGoToCreate = this.onGoToCreate.bind(this);
        this.delete = this.delete.bind(this);
        this.uploadSubmit = this.uploadSubmit.bind(this);
        this.uploadToggle = this.uploadToggle.bind(this);
    }

    public onGoBack() {
        const dest = this.props.services.currentBaseUrl + 'home/';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onGoToCreate() {
        const dest = this.props.services.currentBaseUrl + 'interactions_creator';
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public onLogout() {
        this.setState({ toLogin: true });
    }

    public uploadToggle() {
        const data = this.state.data
        data.uploadModal = !data.uploadModal;
        this.setState({
            data
         });
    }


    public async goToEdit(row) {
        console.log(row);
        const dest = this.props.services.currentBaseUrl + 'templates/' + row.rowData.id
        
        console.log(dest)
        
        this.setState({
            isNavigate: true,
            destination: dest
        })
    }

    public async delete(row) {
        console.log(row.rowData.id);

        const retVal = confirm("Do you want to continue ?");
    
        if(retVal === true) {
                  console.log('delete accepted');
                  const res = await this.props.services.adminAPI.deleteItemGeneral('data_templates', row.rowData.id);
                  
                  if (res.ok) {

                    const templatesRes = await this.props.services.adminAPI.getTemplates();

                    if (templatesRes.ok) {
            
                        const collections = templatesRes.data.templates;
                        
                        const data = this.state.data;

                        data.collections = collections;

                        this.setState({data});
                    }
                    
                }
                  return true;
        } else {
            console.log('delete canceled')
            return false;
        }
    }

    public customTD = props =>{
        return (
          <td>
            {/*tslint:disable-next-line jsx-no-lambda*/}
            <button style={{margin: '3px'}} className="blue-button view-more-data table-action" onClick={() => this.goToEdit(props)}>Edit</button>

            {/*tslint:disable-next-line jsx-no-lambda*/}
            <button style={{margin: '3px'}} className="blue-button view-more-data table-action" onClick={() => this.delete(props)}>Delete</button>
          </td>
        );
    } 

    public async componentDidMount() {
        const {
            match,
            history,
            location,
            services: { isUserLoggedIn, adminAPI, currentUserID },
        } = this.props;

        if (!isUserLoggedIn) { this.setState({ toLogin: true }); }

        const { params: { id: InteractionID } } = match;

        const assetCollectionsDataKey = ["id", "Name","delete"];
        
        const assetCollectionsThead = ["ID", "Name", "Action"];

        const templatesRes = await adminAPI.getTemplates(); 

        if (templatesRes.ok) {
            
            const collections = templatesRes.data.templates;

            this.setState(
                {
                     data: {
                        uploadModal: false,
                        collections,
                        loaded: true,
                        collectionsdatakey: assetCollectionsDataKey,
                        collectionsthead: assetCollectionsThead
                     }
                }
            )
        } else {
            toast.error('Error fetching interaction details!');
        }
    }

    public async uploadSubmit(e) {

        e.preventDefault();

        this.setState({
            loaded: false
         });

         const fileInputElement = e.target.elements.upld;
         const formData = new FormData();
 
         for (const row of fileInputElement.files) {
             formData.append('files', row);
         }
 
        const res = await this.props.services.adminAPI.updloadTemplate(formData)


        if (res.ok) {
            this.uploadToggle();

            const templatesRes = await this.props.services.adminAPI.getTemplates();

            if (templatesRes.ok) {
            
                const collections = templatesRes.data.templates;

                const data = this.state.data;

                data.collections = collections;
            
                this.setState({
                    data
                 });
            }
        }
        else{
            toast.error('Error creating item!');
        }

        this.setState({
            loaded: true
        });
    }

    public render() {
        const {data} = this.state;
    
        if (this.state.toLogin) {
          return <Redirect to="/login" />;
        }

        if (this.state.isNavigate) {
            return <Redirect to={this.state.destination} />;
          }
    
        if (Object.keys(data).length === 0) {
          return <Loader color="#acff24" />;
        }

        return (
            <Wrapper>
              <ToastContainer/>
              <Navbar logoutParent={this.onLogout} />
              <Content>
                <ContentRow className="single-col">
                  <p className="go-back" onClick={this.onGoBack}>&lt; Back</p>
                </ContentRow>
              </Content>

              <Content>
                <Button onClick={this.uploadToggle}>Add New</Button>
                <SortableTbl
                    tblData={data.collections}
                    tHead={data.collectionsthead}
                    dKey={data.collectionsdatakey}
                    customTd={[
                            { custd: this.customTD, keyItem: "edit", sortable: false },
                            { custd: this.customTD, keyItem: "delete", sortable: false }
                        ]}
                    defaultCSS={false}
                />

              </Content>

        

            <Content>
                <Modal isOpen={data.uploadModal} toggle={this.uploadToggle} style={{marginTop: '10%'}}>
                    <ModalHeader toggle={this.uploadToggle}> Template Upload</ModalHeader>
                    <ModalBody>
                        <form onSubmit={this.uploadSubmit}>
                            <Row>
                                <Col xs="12">
                                    <input id="upld" type="file" name="upld" accept=".html,.txt" multiple={false} required={true}/>
                                </Col><br/><br/>

                                <Loader color="#3EE9F7" loaded={data.loaded}>
                                    <Button color="primary" type="submit" className="adminmodalbutton">Submit</Button>
                                    <Button  onClick={this.uploadToggle} className="adminmodalbutton">Cancel</Button>
                                </Loader>

                                </Row>
                            </form>
                    </ModalBody>
                </Modal>
              </Content>

              
              </Wrapper>
        );

    }

}

export default withServices(ListTemplates);


// WEBPACK FOOTER //
// ./src/pages/Admin/Templates/ListTemplates/ListTemplates.tsx